import styled, { keyframes } from "styled-components";
import { device } from "./Breakpoints";
import { secondaryColor } from "./Colors";

// Max width that defines the block size (and for footer header)
export const maxWidthBlock = "900px";

//Font Sizes
export const headingSmall = "30px";
export const headingMedium = "52px";
export const headingLarge = "64px";
export const heading48 = "48px";

export const fontSizeXS = "10px";
export const fontSizeSmall = "12px";
export const fontSizeMedium = "14px";
export const fontSizeMobile = "16px";
export const fontSizeTablet = "18px";
export const fontSizeH1 = "48px";

// Font Line-Height
export const lineheightHeadingSmall = "36px";
export const lineheightHeadingMedium = "58px";
export const lineheight34 = "34px";
export const lineheight68 = "68px";
export const lineheightSmall = "24px";
export const lineheightMedium = "30px";
export const lineheightCaption = "18px";
export const lineheightH1 = "54px";

// letter spacing
export const letterSpacingDruk = "-.025em";
export const letterSpacingPT_serif = "-.015em";
export const letterSpacingH1 = "-0.7px";

//Fonts
export const roboto = "Roboto";
export const ptSerif = "PT serif";
export const drukText = "Druk Text Web";
export const Inter = "Inter";

// Headings PT Serif

export const Heading1 = styled.h2`
    font-family: ${Inter}
    letter-spacing: -0.6px;
    font-size: 28px;
    line-height: 34px;
    font-weight: 700;
    color: #0F0865;

    @media${device.tablet} {
    font-family: ${Inter}
    letter-spacing: -0.6px;
    font-size: 32px;
    line-height: 38px;
    font-weight: 700;
    color: #0F0865;
    }
`;

export const Heading2 = styled.h3`
  color: ${props => (props.color ? props.color : secondaryColor)}; 
  font-size: 24px;
  font-family: ${Inter}
  line-height: 30px;
  font-style: normal;
  font-weight: 700;
  max-width: 600px;
`;

// Headings roboto Municipality
export const HeadingMunicipality = styled.h2.attrs({
  tabIndex: props => (props.tabIndex ? props.tabIndex : "0")
})`
  color: ${props => (props.color ? props.color : secondaryColor)};
  font-family: ${Inter};
  font-weight: bold;
  font-size: ${fontSizeTablet};
  line-height: ${lineheightMedium};
  margin: 0;
  margin-top: ${props => (props.marginTop ? props.marginTop : 0)}
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : 0)};
`;

export const Heading6 = styled.p`
  font-family: ${Inter};
  font-size: 18px;
  line-height: 26px;
  margin: 0;
  max-width: 600px;
`;

// Block

export const SubtitleBlock = styled.h2`
    font-family: ${Inter}
    font-size: ${fontSizeTablet};
    line-height: 26px
    font-weight: 400 !important;
`;

// Captions
export const Caption = styled.p`
  color: ${props => (props.color ? props.color : secondaryColor)};
  font-family: ${Inter};
  font-weight: normal;
  font-size: ${fontSizeMobile}
  text-align: center;
  margin: 8px 0 0 0;
`;

export const CaptionForeignObject = styled.foreignObject`
  font-family: ${Inter};
  font-weight: bold;
  font-size: 7px;
  padding-top:2px;

  @media${device.mobileM} {
    font-size:6px;
  }
  @media${device.mobileL} {
    font-size:5px;
  }

  &> span {
      display: inline-block;
    
    @media${device.mobileL} {
      display: inline;
    }
  }
`;

export const FiguresWrapper = styled.div`
  display: flex;
  max-width: ${props => (props.maxWidth ? props.maxWidth : "100%")};
  margin-top: ${props => (props.marginTop ? props.marginTop : 0)}
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : 0)};
  flex-wrap: ${props => (props.flexWrap ? props.flexWrap : "wrap")};
  gap: 32px;
/*   flex-direction: column;
  @media${device.mobileL} {
    flex-direction: row;
  } */
`;



export const HorizontalLine = styled.div`
      margin-top: 32px;
`;
//Components images

export const scaleInBottomBubble = keyframes`
    from {
      transform: scale(0);
      transform-origin: 50% 50%;
      opacity: 1;
    }
    to {
      transform: scale(1);
      transform-origin: 50% 50%;
      opacity: 1;
    }
  `;

export const scaleInBottomBubbleDouble = keyframes`
    from {
      transform: scale(0);
      transform-origin: 25% 50% 0;
      opacity: 1;
    }
    to {
      transform: scale(1);
      transform-origin: 25% 50% 0;
      opacity: 1;
    }
  `;

export const scaleInBottomLine = keyframes`
    from {
        transform: translateY(0) scaleY(0);
        opacity: 1;
    }
    to {
        transform: translateY(0) scaleY(1);
        opacity: 1;
    }
`;

export const scaleInFigure = keyframes`
from {
  transform: scale(0);
  transform-origin: 25% 50% 0;
  opacity: 1;
}
to {
  transform: scale(1);
  transform-origin: 25% 50% 0;
  opacity: 1;
}
`;

export const drawLine = keyframes`
   from {
        stroke-dashoffset: -20;
   }
   to {
        stroke-dashoffset: 0;
   }
`;

export const circleTransition = keyframes`
    from {
      r: 0px;
    }
    to {
      r: 20px;
    }
`;

export const slideUp = keyframes`
from: {
  transform: translate3d(0, '100%', 0),
  visibility: 'visible'
},
to: {
  transform: translate3d(0, 0, 0)
}
`;

export const dash = keyframes`
from: {
  stroke-dashoffset: 0%;
}   to: {
  stroke-dashoffset: 100%;
}
`;

export const rotate360CW = keyframes`
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(360deg);
}
`;

export const rotate360CCW = keyframes`
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(-360deg);
}
`;
